import React, {useState} from 'react'
import {useSelector} from "react-redux";
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import FormFields from "./form_fields";
import EventGroups from "./event_groups";
import {useFormContext} from "react-hook-form";
import FlaveCheckbox from "./form_fields/raw_fields/flave_checkbox";

const CompanionContent = () => {
  const { formState: { errors }, register } = useFormContext();

  const tagOwner = useSelector(state => state.tagOwner)
  const companionConfig = useSelector(state => state.companion)
  const companionCheckboxText = useSelector(state => state.companion.checkbox_text)
  const companionHeaderText = useSelector(state => state.companion.header_text)

  const inputWidth = useSelector(state => state.input_width) || "8"
  const labelWidth = useSelector(state => state.label_width) || "3"

  const [showCompanionContent, setShowCompanionContent] = useState(false)

  if (!companionConfig.enabled || tagOwner?.no_companion_on_participation_page) {
    return null
  }

  const error = errors?.companion_enabled?.status?.message

  const options = [
    {
      label: <RenderedHtmlContent html={companionCheckboxText}/>,
      value: "1"
    }
  ]

  return <>
    <div key={"companion"} className="companion-row row form-group" >

      <div className="col-12">
        <FlaveCheckbox
          name={"companion_enabled.status"}
          onChange={e => setShowCompanionContent(e.target.checked)}
          label={""}
          options={options}
          errorMessage={error}
        />
      </div>
    </div>
    {showCompanionContent && <div className="companion-content">

      {companionHeaderText && <div className="form-group row companion-header-container">
        <span className={`r-label col-md-${labelWidth} col-form-label optional-label`}/>
        <div className={`col-md-${inputWidth}`}>
          <RenderedHtmlContent html={companionHeaderText}/>
        </div>
      </div>}

      <FormFields tagOwner={null} fieldType={"companion"} register={register} errors={errors}/>

      {companionConfig.show_event_selection && <EventGroups fieldType={"companion"}/>}
    </div>}
  </>
}
export default CompanionContent;